import { render } from "./HomePageSix.vue?vue&type=template&id=108126a4"
import script from "./HomePageSix.vue?vue&type=script&lang=js"
export * from "./HomePageSix.vue?vue&type=script&lang=js"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__